import { useState, useEffect } from 'react';

/**
 * Detecta si el viewport es menor al breakpoint dado.
 * @param {number} breakpoint - ancho en px (default: 768)
 * @returns {boolean}
 */
export function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
}